export default class PressRelease {

    constructor() {
        this.addEvents();
        this.checkAnchor();
    }

    addEvents() {

        $('.press_release__left').on('click', 'a', function(e) {
            e.preventDefault();
            const $menuLinks = $('.press_release__left a');
            $menuLinks.removeClass('active');
            $(this).addClass('active');
            const current = $(this).index() + 1;
            const $targetItem = $('.press_release__item:nth-child(' + current + ')');
            const top = $targetItem.offset().top;
            $('body,html').animate({ scrollTop: top - 150 }, 1000);
        });

        const anchors = document.querySelectorAll('.press_release__left a');

        if(anchors.length > 0) {
            window.addEventListener("scroll", () => {
                const allItems = document.querySelectorAll('.press_release__item');
                const topMenu = document.querySelector('.press_release__left');
                const menu = topMenu.querySelector('.press_release__menu');

                if (topMenu.getBoundingClientRect().top - 160 <= 0) {
                    menu.classList.add('fixed');
                } else {
                    menu.classList.remove('fixed');
                }

                allItems.forEach((el, index) => {
                    const elRect = el.getBoundingClientRect();
                    if (elRect.top - 160 < 0 && elRect.bottom - 160 > 0) {
                        anchors[index].classList.add("active");
                    } else {
                        anchors[index].classList.remove("active");
                    }
                });
            });
        }
    }

    checkAnchor(){
        jQuery( document ).ready(function() {
            let currentHash = window.location.pathname + window.location.hash;
            const $hashItem = $('.press_release__item[data-anchor="' + currentHash + '"]');
            if ($hashItem.length > 0) {
                const top = $hashItem.offset().top;
                $('body,html').animate({scrollTop: top - 150}, 1000);
            }
        });
    }

}




